<template>
  <!-- Footer -->
  <!--<footer class="site-footer">-->
  <!--<div class="site-footer-legal">© 2020 Repnode. All RIGHT RESERVED.</div>-->
  <!--<div class="site-footer-right">-->
  <!--</div>-->
  <!--</footer>-->
</template>

<script>
export default {
  name: 'layout-footer'
}
</script>

<style scoped>

</style>
